// extracted by mini-css-extract-plugin
export default {"cls1":"PaperAbstract-cls1_feO","cls2":"PaperAbstract-cls2_XPT PaperAbstract-cls1_feO","variant-dense":"PaperAbstract-variant-dense_ErK","size-md":"PaperAbstract-size-md_NSU"};